import { ProcessType } from "@/constants/process";
import { cn } from "@/utils/cn";

interface ProcessProps {
  process: ProcessType;
  index: number;
  isLast: boolean;
}

function Process({ process, index, isLast }: ProcessProps) {
  const { title, descriptions } = process;

  return (
    <div className="group relative">
      {/* Step Indicator Circle */}
      <div
        className={cn(
          "absolute -left-[20px] top-2 flex h-10 w-10 items-center justify-center rounded-full border-2 border-white bg-sky-100 text-14 font-semibold text-slate-700 transition-all duration-200 desktop:relative desktop:left-auto desktop:top-auto desktop:mx-auto desktop:mb-4",
          "group-hover:scale-110 group-hover:bg-sky-600 group-hover:text-white group-hover:shadow-lg",
        )}
      >
        {index + 1}
      </div>

      {/* Content Card */}
      <div
        className={cn(
          "ml-8 mr-4 rounded-lg bg-white p-4 shadow-sm transition-all duration-200 tablet:mr-0 desktop:ml-0 desktop:mr-0",
          "border border-slate-100 hover:border-sky-200 hover:shadow-md",
          !isLast && "mb-2 desktop:mb-0",
        )}
      >
        {/* Title */}
        <h3 className="mb-2 text-16 font-semibold text-slate-900 desktop:text-center desktop:text-18">{title}</h3>

        {/* Descriptions */}
        {descriptions.length > 0 && (
          <ul className="space-y-1">
            {descriptions.map((description, idx) => (
              <li key={`desc-${idx}`} className="flex items-start gap-2 text-14 text-slate-600">
                <span className="mt-1 block h-1 w-1 shrink-0 rounded-full bg-slate-400" />
                <span className="desktop:text-center desktop:text-13">{description}</span>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Connector Arrow (Desktop Only) */}
      {!isLast && (
        <div className="absolute right-0 top-8 hidden -translate-y-1/2 desktop:block">
          <svg className="h-6 w-6 -translate-x-2 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      )}
    </div>
  );
}

export default Process;
